import { render, staticRenderFns } from "./FontsSubheader.vue?vue&type=template&id=5ac7eaeb&scoped=true&"
import script from "./FontsSubheader.vue?vue&type=script&lang=js&"
export * from "./FontsSubheader.vue?vue&type=script&lang=js&"
import style0 from "./FontsSubheader.vue?vue&type=style&index=0&id=5ac7eaeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac7eaeb",
  null
  
)

export default component.exports